import { useState, useEffect } from "react";
import {
  GoogleAuthProvider,
  signInWithPopup,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth, db } from "../utils/firebase";
import {
  getAdminEmailList,
  getBoardMemberEmailList,
  getCommunitiesList,
} from "../utils/firebaseOperations";

import { useNavigate, Link } from "react-router-dom";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  Timestamp,
} from "firebase/firestore";

export default function Join() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [adminEmailList, setAdminEmailList] = useState([]);
  const [boardMemberEmailList, setBoardMemberEmailList] = useState([]);
  const [communitiesList, setCommunitiesList] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const adminEmails = await getAdminEmailList();
        const boardMemberEmails = await getBoardMemberEmailList();
        const communities = await getCommunitiesList();
        setAdminEmailList(adminEmails);
        setBoardMemberEmailList(boardMemberEmails);
        setCommunitiesList(communities);
      } catch (error) {
        console.error(error);
        // Here you could set an error state and display an error message to the user
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  // Google Log-In
  const googleProvider = new GoogleAuthProvider();
  const GoogleLogin = async (e) => {
    e.preventDefault();
    try {
      const result = await signInWithPopup(auth, googleProvider);

      const q = query(
        collection(db, "Users"),
        where("email_address", "==", result.user.email)
      );

      const queryProfile = await getDocs(q);

      if (queryProfile.docs.length == 0) {
        if (community === undefined) {
          setWarning("Select your Community");
        } else if (address === "") {
          setWarning("Enter Address");
        } else if (zip === undefined) {
          setWarning("Enter Zip Code");
        } else if (password === "") {
          setWarning("Enter password");
        } else if (confPass !== password) {
          setWarning("Match your password");
        } else if (isChecked !== true) {
          setWarning("Please Accept Terms and Conditions");
        }

        await setDoc(doc(db, "Users", result.user.uid), {
          bio: "",
          community: community.replace(/([a-z0-9])([A-Z])/g, "$1 $2"),
          communitySlug: community,
          dateCreated: Timestamp.fromDate(new Date()),
          userTypeName: "Non-Verified Member",
          userTypeNumber: 1,
          img: "",
          password,
          //
          email_address: email,
          phone_number: "+1" + phoneNumber,
          date_of_birth: dob,
          name: {
            given_name: firstName,
            family_name: lastName,
          },
          address: {
            street,
            city,
            region: state,
            postal_code: zip,
            country: "US",
          },
        });
        // await setDoc(doc(db, "mail", result.user.id + "Admin Email"), {
        //   to: adminEmailList,
        //   message: {
        //     subject: `${result.user.displayName || "New user"} has joined`,
        //     html: `
        //   ${result.user.displayName || "New user"}has joined! 👋
        // `,
        //   },
        // });
        localStorage.setItem("id", result.user.uid);
        navigate("/dashboard");
      } else {
        setWarning(
          <p>
            You already have an account. Go to your{" "}
            <Link to="/dashboard">Dashboard</Link>
          </p>
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [warning, setWarning] = useState("");
  const [community, setCommunity] = useState(undefined);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dob, setDob] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState();
  const [password, setPassword] = useState("");
  const [confPass, setConfPass] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const validateForm = () => {
    if (community === undefined) return "Select your Community";
    if (firstName === "") return "Enter First Name";
    if (lastName === "") return "Enter Last Name";
    if (dob === "") return "Enter Date of Birth";
    if (phoneNumber === "") return "Enter Phone Number";
    if (email === "") return "Enter Email";
    if (street === "") return "Enter Street";
    if (city === "") return "Enter City";
    if (zip === undefined) return "Enter Zip Code";
    if (password === "") return "Enter password";
    if (confPass !== password) return "Match your password";
    if (isChecked !== true) return "Please Accept Terms and Conditions";
    return null;
  };

  const handleStateSelect = (event) => {
    setState(event.target.value);
  };

  // Registration function
  const Register = async (e) => {
    e.preventDefault();
    try {
      const warning = validateForm();
      if (warning) {
        setWarning(warning);
      } else {
        const q = query(collection(db, "Users"), where("email", "==", email));
        const queryProfile = await getDocs(q);
        if (queryProfile.docs[0].exists()) {
          setWarning("User already exists! Please sign in");
        } else {
          setWarning(null);
          AddUser();
        }
      }
    } catch (error) {
      setWarning(null);
      AddUser();
    }
  };

  // function to add user to firestore with info from registration form
  async function AddUser() {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    setDoc(doc(db, "Users", result.user.uid), {
      bio: "",
      community: community.replace(/([a-z0-9])([A-Z])/g, "$1 $2"),
      communitySlug: community,
      dateCreated: Timestamp.fromDate(new Date()),
      userTypeName: "Non-Verified Member",
      userTypeNumber: 1,
      img: "",
      password,
      //
      email_address: email,
      phone_number: "+1" + phoneNumber,
      date_of_birth: dob,
      name: {
        given_name: firstName,
        family_name: lastName,
      },
      address: {
        street,
        city,
        region: state,
        postal_code: zip,
        country: "US",
      },
    });

    // await setDoc(doc(db, "mail", result.user.uid + "Admin Email"), {
    //   to: adminEmailList,
    //   message: {
    //     subject: `${firstName || "New user"} has joined`,
    //     html: `
    //       ${firstName || "New user"} has joined! 👋
    //     `,
    //   },
    // });
    // await setDoc(doc(db, "mail", result.user.uid + "Welcome Email"), {
    //   to: email,
    //   message: {
    //     subject: `Welcome to DAO ${firstName || "New user"}!`,
    //     html: `
    //       This is the welcome eamil ${firstName || "New user"} 👋
    //       You will be approved shortly
    //     `,
    //   },
    // });
    await signInWithEmailAndPassword(auth, email, password);
    navigate("/dashboard");
  }
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <section className="bg-user-home user-pages d-flex align-items-center">
        <div className="bg-overlay bg-overlay-white" />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-5 col-md-8">
              <div className="login-page bg-white shadow-lg rounded p-4 mt-4 position-relative">
                <div className="text-center">
                  <h5 className="mb-4 pb-2">Join a Community</h5>
                </div>
                <form className="login-form">
                  <div className="row">
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Community <span className="text-danger">*</span>
                        </label>
                        <select
                          value={community}
                          onChange={(e) => setCommunity(e.target.value)}
                          required
                          className="my-1 mr-sm-2 form-control"
                          id="inlineFormCustomSelectPref"
                        >
                          <option value={undefined}>
                            Select Your Community
                          </option>
                          {communitiesList.map((community, index) => {
                            return (
                              <option key={index} value={community.slug}>
                                {community.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          First name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          placeholder="First Name :"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Last name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          required
                          placeholder="Last Name :"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Your Date of Birth{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="dob"
                          required
                          placeholder="Your Date of Birth :"
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Your Phone Number{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="phone"
                          className="form-control"
                          name="phone"
                          required
                          placeholder="Your Phone Number :"
                          value={phoneNumber}
                          onChange={(e) => setphoneNumber(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Your Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          required
                          placeholder="Your Email :"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-bold">
                        Your Address
                      </label>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small ">
                          Street <span className="text-danger">*</span>
                        </label>
                        <input
                          type="address"
                          className="form-control"
                          name="address"
                          required
                          placeholder="Street :"
                          value={street}
                          onChange={(e) => setStreet(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small ">
                          City <span className="text-danger">*</span>
                        </label>
                        <input
                          type="address"
                          className="form-control"
                          name="address"
                          required
                          placeholder="City :"
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small ">
                          State <span className="text-danger">*</span>
                        </label>
                        <select
                          name="state"
                          value={state}
                          onChange={handleStateSelect}
                        >
                          <option value="AL">AL</option>
                          <option value="AK">AK</option>
                          <option value="AZ">AZ</option>
                          <option value="AR">AR</option>
                          <option value="CA">CA</option>
                          <option value="CO">CO</option>
                          <option value="CT">CT</option>
                          <option value="DE">DE</option>
                          <option value="DC">DC</option>
                          <option value="FL">FL</option>
                          <option value="GA">GA</option>
                          <option value="HI">HI</option>
                          <option value="ID">ID</option>
                          <option value="IL">IL</option>
                          <option value="IN">IN</option>
                          <option value="IA">IA</option>
                          <option value="KS">KS</option>
                          <option value="KY">KY</option>
                          <option value="LA">LA</option>
                          <option value="ME">ME</option>
                          <option value="MD">MD</option>
                          <option value="MA">MA</option>
                          <option value="MI">MI</option>
                          <option value="MN">MN</option>
                          <option value="MS">MS</option>
                          <option value="MO">MO</option>
                          <option value="MT">MT</option>
                          <option value="NE">NE</option>
                          <option value="NV">NV</option>
                          <option value="NH">NH</option>
                          <option value="NJ">NJ</option>
                          <option value="NM">NM</option>
                          <option value="NY">NY</option>
                          <option value="NC">NC</option>
                          <option value="ND">ND</option>
                          <option value="OH">OH</option>
                          <option value="OK">OK</option>
                          <option value="OR">OR</option>
                          <option value="PA">PA</option>
                          <option value="RI">RI</option>
                          <option value="SC">SC</option>
                          <option value="SD">SD</option>
                          <option value="TN">TN</option>
                          <option value="TX">TX</option>
                          <option value="UT">UT</option>
                          <option value="VT">VT</option>
                          <option value="VA">VA</option>
                          <option value="WA">WA</option>
                          <option value="WV">WV</option>
                          <option value="WI">WI</option>
                          <option value="WY">WY</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Zip Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="zip"
                          required
                          placeholder="Your Zip Code :"
                          value={zip}
                          onChange={(e) => setZip(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Password <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          required
                          minLength="6"
                          placeholder="Password :"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label small fw-bold">
                          Confirm Password{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          required
                          minLength="6"
                          placeholder="Confirm Password :"
                          value={confPass}
                          onChange={(e) => setConfPass(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                            id="flexCheckDefault"
                            required
                            onClick={() => setIsChecked(!isChecked)}
                          />
                          <label
                            className="form-check-label small fw-bold"
                            htmlFor="flexCheckDefault"
                          >
                            I Accept{" "}
                            <a href="#" className="text-primary">
                              Terms And Condition
                            </a>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="warning text-danger text-center my-2">
                      {warning}
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-primary w-100"
                        onClick={Register}
                      >
                        Register
                      </button>
                    </div>
                    <div className="col-12 mt-4 text-center">
                      <h6>Or Sign Up With</h6>
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-sm-12 mt-4">
                          <button
                            onClick={GoogleLogin}
                            className="btn w-100 btn-light"
                          >
                            <i className="mdi mdi-google text-danger" /> Google
                          </button>
                        </div>
                      </div>
                    </div>
                    {/*end col*/}
                    <div className="mx-auto">
                      <p className="mb-0 mt-3">
                        <small className="text-dark me-2">
                          Already have an account ?
                        </small>
                        <Link to="/Login" className="text-dark fw-bold">
                          Sign in
                        </Link>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
              {/*end login*/}
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}
        </div>
      </section>
    </>
  );
}
